export const verificationChecklist = [
  {
    title: 'Verify the facts',
    desc: 'Confirm that names, dates, times, locations, observations, and actions match the original records.',
  },
  {
    title: 'Check the chronology',
    desc: 'Make sure the sequence of events is consistent with the available logs and documentation.',
  },
  {
    title: 'Identify missing information',
    desc: 'Do not fill gaps with assumptions or invented details.',
  },
  {
    title: 'Protect sensitive information',
    desc: "Follow your employer's rules and the applicable privacy requirements before entering information into an AI service.",
  },
  {
    title: 'Review the language',
    desc: 'Ensure that the document is objective, clear, and appropriate for its intended purpose.',
  },
  {
    title: 'Follow internal procedures',
    desc: 'Use the required reporting format and obtain authorization or supervisor review where necessary.',
  },
  {
    title: 'Approve the final version',
    desc: 'AI can assist with drafting and organization, but the authorized professional remains responsible for the document.',
  },
];
